import { render } from "./Checkbox.vue?vue&type=template&id=415459e8"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import exportComponent from "/home/berisalam-console-demo/webapps/berisalam-console-demo/releases/1787064449663/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__